import Context from 'managers/Context';
import { SALESORDERS } from 'constants/Entities';
import { getLiteral } from 'utils/getLiteral';
import { errorToast, infoToast } from 'utils/toast';

const getManager = () => Context.entityManager.getEntitiesManager(SALESORDERS);

export function autoCompleteSearchSalesOrders({ search }) {
    return (dispatch) =>
        new Promise((resolve, reject) => {
            const filter = {
                matchingName: {
                    dataType: 'search',
                    id: 'matchingName',
                    value: search,
                },
            };

            Context.domainManager.getEntityList(
                SALESORDERS.entity,
                0,
                30,
                filter,
                '',
                -1,
                null,
                false,
                (data) => {
                    let response = data;
                    const manager = getManager();
                    if (manager.transformDataForEntityList) {
                        response = manager.transformDataForEntityList(data);
                    }
                    resolve(response.Data || response.MetaData || []);
                },
                () => {
                    console.error('an error occurred in pseudo fuzzy search for salesorders');
                    reject();
                },
                false,
            );
        });
}

export function duplicateEntity(id) {
    return () =>
        Context.entityManager
            .duplicate(SALESORDERS, id)
            .then((response) => {
                infoToast({ text: getLiteral('label_duplicate_success') });
                return response;
            })
            .catch((e) => {
                console.error(e);
                if (!e || (e && e.serverError)) {
                    errorToast({ text: getLiteral('error_generalerror') });
                }
            });
}

export function getSalesRecordsStatistics(type) {
    return (_dispatch, getState) => {
        const entityFilters = getState().entityFilters[SALESORDERS.entity];
        let filters = entityFilters ? entityFilters.filters || {} : {};
        const operators = entityFilters ? entityFilters.operators || {} : {};

        if (type?.value) {
            if (filters.salesOrderType) {
                filters.salesOrderType.value = [type];
            } else {
                filters.salesOrderType = {
                    completeValues: null,
                    hideForCount: true,
                    id: 'salesOrderType',
                    value: [type],
                };
            }
        } else {
            const { salesOrderType: _removed, ...rest } = filters;
            filters = rest;
        }

        return Context.domainManager.getSalesRecordsStatistics(filters, operators, {});
    };
}
